import { render, staticRenderFns } from "./RegistrationAgreementSigningPage.vue?vue&type=template&id=051b3579&scoped=true"
import script from "./RegistrationAgreementSigningPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationAgreementSigningPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationAgreementSigningPage.vue?vue&type=style&index=0&id=051b3579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b3579",
  null
  
)

export default component.exports